import React, { FC } from 'react'
import { Adsense, AdsenseProps } from './Adsense'
import { YandexAds, YandexAdsProps } from './YandexAds'
import { ADS_ENABLED } from '../../env'
import { AdvertisingByCountry } from './AdvertisingByCountry'
import { useIsClient } from '../hooks/useIsClient'

export const Advertising: FC<{
  adsense: AdsenseProps
  yandex: YandexAdsProps
  className?: string
}> = ({ className, adsense, yandex }) => {
  const isClient = useIsClient()

  if (ADS_ENABLED && isClient) {
    return (
      <AdvertisingByCountry
        adsense={<Adsense className={className} {...adsense} />}
        yandex={<YandexAds className={className} {...yandex} />}
      />
    )
  }

  return null
}
